import React, { useMemo, useState, useEffect } from "react"
import { Button, UncontrolledAlert } from "reactstrap"
import { FaEdit, FaStreetView, FaAddressCard } from "react-icons/fa"
import { useNavigate } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import TableContainer from "../../../components/Common/DataTableContainer"
import { fetchPvs } from "../../../redux/actions/pvs"
import ActionDropdown from "components/ActionDropdown"
import { toast } from "react-toastify"
import { RESET_PVS_REGISTRATION } from "../../../redux/types/pvs"

const PvsList = () => {
  document.title = "PVS List"

  const history = useNavigate()
  const dispatch = useDispatch()
  const pvsState = useSelector(state => state.pvs)
  const fetchPvsState = useSelector(state => state.screens.pvs.fetchPvs)
  const token = useSelector(state => state.auth.token)

  const [userData, setUserData] = useState([])
  const [alert, setAlert] = useState({
    visible: false,
    message: "",
    color: "success",
  })


  const columns = useMemo(
    () => [
      {
        header: "Name",
        accessorKey: "seller_name",
        enableColumnFilter: true,
        enableSorting: true,
      },
      {
        header: "Mobile Number",
        accessorKey: "whatsapp_number",
        enableColumnFilter: true,
        enableSorting: true,
      },
      {
        header: "Email ID",
        accessorKey: "seller_email_id",
        enableColumnFilter: true,
        enableSorting: true,
      },
      {
        header: "PVS No",
        accessorKey: "token_code",
        enableColumnFilter: true,
        enableSorting: true,
      },
      {
        header: "Brand Name",
        accessorKey: "brand_name",
        enableColumnFilter: true,
        enableSorting: true,
      },
      {
        header: "Registered date",
        accessorKey: "created_date",
        enableColumnFilter: true,
        enableSorting: true,
      },

      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        enableSorting: false,
        cell: info => {
          const row = info.row.original
          return (
            <div>
              <button
                className="btn btn-sm btn-info me-2"
                onClick={() => history(`/edit-pvs/${row.enc_pvs_entry_id}`)}
                title="Edit PVS"
              >
                Edit
              </button>
              <button
                className="btn btn-sm btn-primary me-2"
                onClick={() =>
                  history(`/view-user/pvs/${row.enc_pvs_entry_id}`)
                }
                title="View PVS"
              >
                View User
              </button>
              <ActionDropdown buttonLabel="Card">
                <button
                  className="dropdown-item"
                  onClick={() => window.open(`${row.pvs_card_link}`, "_blank")}
                >
                  View
                </button>
                <button
                  className="dropdown-item"
                  onClick={() => handleResend(row.enc_pvs_entry_id)}
                >
                  Resend
                </button>
              </ActionDropdown>
              {/* <button
                className="btn btn-sm btn-primary me-2"
                title="Resend PVS Card"
                onClick={() => handleResend(row.enc_pvs_entry_id)}
              >
                <FaRegPaperPlane />
              </button>
              {row.pvs_card_link && (
                <Button
                  size="md"
                  color="primary"
                  className="w-20 text-transform"
                  onClick={() => window.open(`${row.pvs_card_link}`, "_blank")}
                >
                  View Details
                </Button>
              )} */}
            </div>
          )
        },
      },
    ],
    [history]
  )

  const handleResend = async enc_pvs_entry_id => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/pvs/resend-pvs-card/${enc_pvs_entry_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      if (!response.ok) {
        throw new Error("Failed to resend PVS card")
      }
      const data = await response.json()
      toast.success("PVS card resend successfully!")
      // setAlert({
      //   visible: true,
      //   message: "PVS card resent successfully!",
      //   color: "success",
      // })
    } catch (error) {
      console.error(error)
      toast.error("PVS card resend failed!")
      // setAlert({
      //   visible: true,
      //   message: "Error resending PVS card...",
      //   color: "danger",
      // })
    }

    // auto-hide alert after 3 seconds
    setTimeout(() => setAlert(prev => ({ ...prev, visible: false })), 3000)
  }

  useEffect(() => {
    dispatch({ type: RESET_PVS_REGISTRATION })
    dispatch(fetchPvs({ status: "approved" }))
  }, [])

  useEffect(() => {
    if (pvsState && Array.isArray(pvsState.approvedPvsList)) {
      setUserData(pvsState.approvedPvsList)
    }
  }, [pvsState])

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="mb-3 pb-2"></div>
        <div className="d-flex align-items-center justify-content-between mb-3">
          <div className="flex-grow-1">
            <h2 className="h4 nom-title mb-0">PVS Members</h2>
          </div>
          <div style={{ position: "relative" }}>
            {/* <Button
              color="success"
              onClick={() => (window.location.href = "/pvs-form")}
            >
              Go to PVS Form
            </Button> */}

            {/* Overlapping alert on button */}
            {alert.visible && (
              <UncontrolledAlert
                color={alert.color}
                style={{
                  position: "absolute",
                  top: "-5px", // adjust vertical position
                  right: "-5px", // adjust horizontal position
                  padding: "0.75rem 0.75rem",
                  minWidth: "400px",
                  zIndex: 9999,
                  fontSize: "1rem",
                  textAlign: "center",
                }}
              >
                {alert.message}
              </UncontrolledAlert>
            )}
          </div>
        </div>
        <TableContainer
          defaultPageSize={20}
          columns={columns}
          data={userData || []}
          isGlobalFilter={true}
          isPagination={true}
          isCustomPageSize={true}
          SearchPlaceholder="Search records..."
          pagination="pagination"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          theadClass="table-light"
          divClassName="table-responsive mb-4 nominee-tbl-wrapper"
          noDataMessage={fetchPvsState.message}
        />
      </div>
    </div>
  )
}

export default PvsList
